const doc = [({"da":({"js":({"admin":({"highscore_generations":({"participants":({"schools_uni_c_id":"Skolens UNI-C ID", "export_csv":"Eksporter CSV"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;